@if (value) {
    <span class="copy-cell" matTooltip="Click to copy" (click)="copy($event)">
        <span class="copy-cell-value">{{ value }}</span>
        <i class="pi pi-copy copy-cell-icon" aria-hidden="true"></i>
    </span>
}
